import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import TicketBuilderComponent from './js/ticket-builder.component';

ComponentsFactory.getInstance().define('ticket-builder', TicketBuilderComponent);
